import { FinalData } from "@/types/onboarding";
import axios from "axios";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const onboardingService = {
  async verifyEmail(emailID: string) {
    const response = await axios.get(
      `${API_BASE_URL}/singup_email_verify/${emailID}`
    );
    return response.data;
  },

  async verifyPhone(phoneID: string) {
    const response = await axios.get(
      `${API_BASE_URL}/singup_phone_verify/${phoneID}`
    );
    return response.data;
  },

  async verifyGST(GST: string) {
    const response = await axios.get(
      `${API_BASE_URL}/singup_gst_verify/${GST}`
    );
    return response.data;
  },

  async verifyPAN(Pan: string) {
    const response = await axios.get(
      `${API_BASE_URL}/singup_pan_verify/${Pan}`
    );
    return response.data;
  },

  async verifyAadhar(aadhar: string) {
    const response = await axios.get(
      `${API_BASE_URL}/singup_aadhar_verify/${aadhar}`
    );
    return response.data;
  },
  async getUser(userID: string) {
    const response = await axios.get(`${API_BASE_URL}/user/${userID}`);
    return response.data;
  },
  async registerUser(userData: FinalData) {
    const response = await axios.post(
      `${API_BASE_URL}/registration`,
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  },
};
